import StatusDto from './StatusDto'
import UserDto from './UserDto'

/**
 * @member {Number} id
 * @member {Number} application_id
 * @member {Date} date
 * @member {string|null} description
 * @member {StatusDto} newStatus
 * @member {StatusDto} oldStatus
 * @member {string|null} shownName
 * @member {Number} timestamp
 * @member {UserDto|null} user
 */
export default class ApplicationLogDto {
  id
  application_id
  date
  description
  newStatus
  oldStatus
  shownName
  timestamp
  user

  /**
   * @param {Number} id
   * @param {Number} application_id
   * @param {Date} date
   * @param {string|null} description
   * @param {string} current_status
   * @param {StatusDto} newStatus
   * @param {StatusDto} oldStatus
   * @param {Number} timestamp
   * @param {UserDto} user
   */
  constructor({
    id,
    application_id,
    date,
    description,
    newStatus,
    oldStatus,
    timestamp,
    user
  }) {
    const properties = {
      configurable: false,
      enumerable: true,
      writable: false
    }

    let shownName = user?.name || user?.email || user?.phone
    id = Number(id)
    application_id = Number(application_id)
    date = new Date(timestamp * 1000)
    description = description || description === '' ? String(description) : null
    newStatus = new StatusDto(Object.assign({}, newStatus))
    oldStatus = new StatusDto(Object.assign({}, oldStatus))
    shownName = shownName ? String(shownName) : null
    timestamp = Number(timestamp)
    user = new UserDto(Object.assign({}, user ?? {}))

    Object.defineProperty(this, 'id', Object.assign({ value: id }, properties))
    Object.defineProperty(this, 'application_id', Object.assign({ value: application_id }, properties))
    Object.defineProperty(this, 'date', Object.assign({ value: date }, properties))
    Object.defineProperty(this, 'description', Object.assign({ value: description }, properties))
    Object.defineProperty(this, 'newStatus', Object.assign({ value: newStatus }, properties))
    Object.defineProperty(this, 'oldStatus', Object.assign({ value: oldStatus }, properties))
    Object.defineProperty(this, 'shownName', Object.assign({ value: shownName }, properties))
    Object.defineProperty(this, 'timestamp', Object.assign({ value: timestamp }, properties))
    Object.defineProperty(this, 'user', Object.assign({ value: user }, properties))
    Object.freeze(this)
  }
}
